<template>
    <div class="row">

      <div class="col-12 card">
        <h4>Отчёт по видам отходов</h4>
        <br><small v-if="this.startDate && this.endDate">c {{ format_date(this.startDate, 'date') }} по {{ format_date(this.endDate, 'date') }}</small>
        <div class="row justify-content-space-between">
            <div class="col-12">
              <div class="top-24">
                <div class="row">
                  <div class="col-6">
                    <div class="text-field">
                      <label class="text-field__label">Дата начала</label>
                      <div class="text-field__icon">
                        <input
                          class="text-field__input"
                          type="date"
                          v-model="startDate"
                          @change="handleDateChange"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="text-field">
                      <label class="text-field__label">Дата окончания</label>
                      <div class="text-field__icon">
                        <input
                          class="text-field__input"
                          type="date"
                          v-model="endDate"
                          @change="handleDateChange"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="WasteReports">
                <WasteReportsList/>
              </div>
              <div class="row" v-else>
                Идёт загрузка...
              </div>
            </div>
        </div>
      </div>
    </div>
</template>
  
  <script>
    import WasteReportsList from "@/components/Ecology/WasteReports/WasteReportsList.vue";
    import moment from 'moment'

    export default {
      components: { WasteReportsList },
      data() {
        return {
          title: "Отчёт по видам отходов",
          startDate: this.year_ago(),
          endDate: this.today_date(),
        }
      },
      computed: {
        currentUser() {
          return this.$store.state.auth.user;
        },
        WasteReports() {
          return this.$store.state.eco_waste_reports
        },
      },
      methods: {
        year_ago(){
          const yearAgo = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000);

          return moment(String(yearAgo)).format('YYYY-MM-DD')
        },
        today_date(){
            const today = new Date();
            return moment(String(today)).format('YYYY-MM-DD')
        },
        handleDateChange() {
          if (this.startDate && this.endDate) {
            this.$store.dispatch("fetchEcologyWasteReports", {
              start_date: this.startDate,
              finish_date: this.endDate
            });
          }
        },
        format_date(value, time='NaN'){
          if (value) {
            if (time != 'NaN') {
              return moment(String(value)).format('DD.MM.YYYY')
            } else {
              return moment(String(value)).format('DD.MM.YYYY HH:mm')
            }
          }
        },
      },
      created() {
        this.$store.dispatch("fetchEcologyWasteReports", {
          start_date: this.startDate,
          finish_date: this.endDate
        });
      },
    };
  </script>
  